import { Pipe, PipeTransform } from '@angular/core';
import { DanoneMslProduct } from '../models/entities/danone-msl_product';


@Pipe({
  name: 'msl-pipe'
})

export class MslPipe implements PipeTransform {
  
  constructor(){}


  transform(danoneMslProduct: DanoneMslProduct, field: string): any {
    let result = danoneMslProduct[field];
//style='background-color:red' class='tip'
     if ( (field == 'rank1') || (field == 'rank2') || (field == 'rank3')){

      if  (danoneMslProduct[field] <= 100){
                result = "<div class='tip-red' >"  + danoneMslProduct[field] + "</div>";
      }  else {
        if  (danoneMslProduct[field] <= 200){
          result = "<div class='tip-orange' >"   + danoneMslProduct[field] + "</div>";
        } else {
          if  (danoneMslProduct[field] <= 300){
            result = "<div class='tip-blue'>"   + danoneMslProduct[field] + "</div>";
          } else {
            result = "<div class='tip-gray' >"   + danoneMslProduct[field] + "</div>";
          }
        }
      }
 
    }
    return result;
  }
}
